export const colors = {
  red: "#ff404b",
  yellow: "#ffce5a",
  blue: "#1baabd",
  green: "#1bbd9d",
  purple: "#cc50f2",
  orange: "#ff7f4f",
  darkGrey: "#5f5f5f",
};
